module.exports = __webpack_public_path__ + "static/york-college-student-mobile-bus-ticket-9d7d4e45725a6c0dd0c4dd53aca129c2.jpg";